<header class="w-100 text-center">
  <!-- <img src="../../../../assets/images/logo.header.png" height="125px" width="auto"> -->
  <img src="../../../../assets/images/mascot/MIRA HR Mascot-02.jpg" height="425px" width="auto">

  <!-- <h3 class="font-italic">[Company Name/Logo]</h3> -->
  <h2 class="font-weight-light small-caps title mt-2">See you soon!</h2>
</header>
<div class="text-center display-5">Logging out, please wait...</div>
